/**
 * The Hindi twin of each /reports/<plan>/ product page — the hreflang pair.
 *
 * Since the 2026-09-30 cleanup release every English report-intent landing
 * (/career-report/, /marriage-report/, …) 301s to the /reports/<plan>/ page it
 * sells, so the English half of each Hindi report landing's cluster is that
 * product page. Both halves read this one table: the product page's metadata,
 * the Hindi landing's metadata and the sitemap rows, so the pair is reciprocal
 * by construction. Dependency-free on purpose (the sitemap Worker imports it).
 * `hindi-report-twins.test.tsx` pins it to the Hindi landing routes and their
 * `reportSlug`.
 */
export const REPORT_PLAN_HINDI_TWINS: Readonly<Record<string, string>> = {
  "career-report": "/hi/career-report/",
  "marriage-report": "/hi/marriage-report/",
  "dosha-remedy-plan": "/hi/dosha-remedy-plan/",
};

/** The English report product page a Hindi report landing pairs with, or null. */
export function reportPlanForHindiTwin(hindiPath: string): string | null {
  const entry = Object.entries(REPORT_PLAN_HINDI_TWINS).find(([, path]) => path === hindiPath);
  return entry ? `/reports/${entry[0]}/` : null;
}
